// extracted by mini-css-extract-plugin
export default {"base":"BaseLayout-module--base--e85c2","container":"BaseLayout-module--container--199e2"};